import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'
import { Heading, ContainerBox } from './AdminStyle';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

@inject('tournamentStore', 'userStore', 'adminStore')

@observer
class TournamentRegistrations extends Component {

  componentWillMount() {
    this.props.tournamentStore.getRegistrations()
  }

  sortDates(a, b, order) {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;
    const { isRegistrations, registrations } = this.props.tournamentStore;
    let registrationItems = []

    if (isRegistrations) {
      registrations.map((app, idx) =>
        registrationItems.push({
          objectId: app.objectId,
          date: moment(app.createdAt).locale("en").format('DD/MM/YYYY'),
          tournament: app.tournament.name,
          teamName: app.participant && app.participant.company && app.participant.company.name,
          firstParticipant: app.participant && (app.participant.firstname + ' ' + app.participant.lastname),
          firstParticipantGolfcourse: app.participant && app.participant.homeGolfCourse,
          firstParticipantHandicap: app.participant && app.participant.handicap,
          secondParticipant: app.externalParticipants[0] && (app.externalParticipants[0].firstname + ' ' + app.externalParticipants[0].lastname),
          secondParticipantGolfcourse: app.externalParticipants[0] && app.externalParticipants[0].golfcourse,
          secondParticipantHandicap: app.externalParticipants[0] && app.externalParticipants[0].handicap,
          isWaitlist: app.isWaitlist ? '✓' : '✗',
        })
      )
    }




    return (
      <div>
        {(isAdmin || isLoge) ?
          <div>

            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox>
                  <Heading>TURNIER ANMELDUNGEN</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table applications'}>
                    {!isRegistrations
                      ? "Keine Anmeldungen"
                      : <BootstrapTable data={registrationItems} borderless={true} hover={true} search pagination exportCSV csvFileName={"tournament_registrations.csv"}>
                        <TableHeaderColumn dataField="objectId" isKey>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="date" dataSort={true} sortFunc={this.sortDates}>angemeldet am</TableHeaderColumn>
                        <TableHeaderColumn dataField="tournament" dataSort={true}>Turniername</TableHeaderColumn>
                        <TableHeaderColumn dataField="teamName">Teamname</TableHeaderColumn>
                        <TableHeaderColumn dataField="firstParticipant" dataSort={true}>Erster Teilnehmer</TableHeaderColumn>
                        <TableHeaderColumn dataField="firstParticipantGolfcourse" dataSort={true}>Heimatgolfplatz (Erster Teilnehmer)</TableHeaderColumn>
                        <TableHeaderColumn dataField="firstParticipantHandicap" dataSort={true}>Handicap (Erster Teilnehmer)</TableHeaderColumn>
                        <TableHeaderColumn dataField="secondParticipant" dataSort={true}>Zweiter Teilnehmer</TableHeaderColumn>
                        <TableHeaderColumn dataField="secondParticipantGolfcourse" dataSort={true}>Heimatgolfplatz (Zweiter Teilnehmer)</TableHeaderColumn>
                        <TableHeaderColumn dataField="secondParticipantHandicap" dataSort={true}>Handicap (Zweiter Teilnehmer)</TableHeaderColumn>
                        <TableHeaderColumn dataField="isWaitlist" dataSort={true}>Warteliste</TableHeaderColumn>
                      </BootstrapTable>
                    }
                  </div>

                </ContainerBox>
              </Col>
            </Row>
          </div>
          : ''}

      </div>
    )
  }
}

TournamentRegistrations.propTypes = {
}

export default TournamentRegistrations



// WEBPACK FOOTER //
// /src/components/admin/TournamentRegistrations.js